import Link from 'next/link'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { Button } from 'antd'
import styled from 'styled-components'

import {
  IconAiScriptGeneratorCreateVideo,
  IconVideoDownloaderDownload,
} from '@/components/common/Icons'

import { Area } from './styles'

type ExportAreaProps = {
  onDownload?: () => void
  onCreateVideo?: () => void

  disabled?: boolean

  className?: string
}

export const ExportArea: FC<ExportAreaProps> = ({
  onDownload,
  onCreateVideo,

  disabled,
}) => {
  const { t } = useTranslation('common')

  return (
    <ExportAreaContainer>
      <DownloadButton
        size="large"
        type="default"
        css={{
          marginBottom: '22px',
        }}
        onClick={onDownload}
        disabled={disabled}
      >
        <IconVideoDownloaderDownload />
        {t('Download Image')}
      </DownloadButton>

      <CreateVideoButton
        size="large"
        type="primary"
        css={{
          marginBottom: '29px',
        }}
        onClick={onCreateVideo}
        disabled={disabled}
      >
        <IconAiScriptGeneratorCreateVideo />
        {t('Create Video')}
      </CreateVideoButton>

      <SwitchGeneratorLink href="/tools/ai-video-generator">
        {t('Switch an AI Video Generator')}
      </SwitchGeneratorLink>
    </ExportAreaContainer>
  )
}

const ExportAreaContainer = styled(Area)`
  grid-column: 2;
  grid-row: 2;

  margin: auto;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.screenMD}px) {
    grid-column: auto;
    grid-row: auto;
  }
`

const DownloadButton = styled(Button)`
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 66px;
  border: 2px solid #146ef5;
  border-radius: 14px;

  font-family: 'Noto Sans CJK';
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;

  color: #146ef5;

  svg path {
    fill: currentColor;
  }
`

const CreateVideoButton = styled(Button)`
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 66px;
  border-radius: 14px;

  font-family: 'Noto Sans CJK';
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;

  svg path {
    fill: currentColor;
  }
`

const SwitchGeneratorLink = styled(Link)`
  font-family: 'Noto Sans CJK';
  font-size: 20px;
  line-height: 28px;
  color: #146ef5;
`
